import { INITIAL_DATA_SELECTOR_DATA } from '@atoms/dataSelectors/dataSelector/dataSelector.data';

import type { DropDownData } from '@stratumn/studio-shared';

export const initialDropDownData: DropDownData = {
  title: 'Default Drop Down Title',
  required: true,
  ...INITIAL_DATA_SELECTOR_DATA
};
